import React from 'react'
import WhenStep from 'app/React/Components/misc/WhenStep'
import Step1 from 'app/React/Components/Main/Steps/Step1'
import Step2 from 'app/React/Components/Main/Steps/Step2'
import Step3 from 'app/React/Components/Main/Steps/Step3'
import Step4 from 'app/React/Components/Main/Steps/Step4'
import Step5 from 'app/React/Components/Main/Steps/Step5'

export default function Main() {
  return (
    <main>
      <WhenStep step={1}>
        <Step1/>
      </WhenStep>
      <WhenStep step={2}>
        <Step2/>
      </WhenStep>
      <WhenStep step={3}>
        <Step3/>
      </WhenStep>
      <WhenStep step={4}>
        <Step4/>
      </WhenStep>
      <WhenStep step={5}>
        <Step5/>
      </WhenStep>
    </main>
  )
}
